// extracted by mini-css-extract-plugin
export default {"error":"d99bbcd3b64f"};